import { axios, base } from '../http';

export const getKqtScheduleTypeListPage = (params) => {
  return axios.get(`${base}/api/KqtScheduleType/get`, { params: params });
};

export const removeKqtScheduleType = (params) => {
  return axios.delete(`${base}/api/KqtScheduleType/delete`, { params: params });
};

export const editKqtScheduleType = (params) => {
  return axios.put(`${base}/api/KqtScheduleType/put`, params);
};

export const addKqtScheduleType = (params) => {
  return axios.post(`${base}/api/KqtScheduleType/post`, params);
};

// 排班各天设置�?

export const getKqtScheduleDailySettingListPage = (params) => {
  return axios.get(`${base}/api/KqtScheduleDailySetting/get`, {
    params: params,
  });
};

export const removeKqtScheduleDailySetting = (params) => {
  return axios.delete(`${base}/api/KqtScheduleDailySetting/delete`, {
    params: params,
  });
};

export const addKqtScheduleDailySetting = (params) => {
  return axios.post(`${base}/api/KqtScheduleDailySetting/post`, params);
};

export const getDailyTime = (params) => {
  return axios.get(`${base}/api/KqtScheduleDailySetting/GetDailyTime`, {
    params: params,
  });
};

// 考勤记录查看

export const getKqtGatherRawHistoryListPage = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/get`, { params: params });
};

//导出考勤记录

export const exportKqtGatherRawHistory = (params) => {
  return axios.get(
    `${base}/api/KqtGatherRawHistory/ExportKqtGatherRawHistory`,
    {
      params: params,
      skipGlobalHttpErrorToast: true,
      responseType: "blob", // 指定响应类型�?blob
    },
  );
};

//部门考勤记录

export const getDeptRecordsPage = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/GetDeptRecords`, {
    params: params,
  });
};

//导出部门考勤记录

export const exportDeptRecords = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/ExportDeptRecords`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

export const getUserMonthRecords = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/GetUserMonthRecords`, {
    params: params,
  });
};

export const getUserMonthDetail = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/GetUserMonthDetail`, {
    params: params,
  });
};

//导出个人考勤记录汇�?�?

export const exportUserMonthDetail = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/ExportUserMonthDetail`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//部门每日考勤汇�?

export const getDeptDailyDetail = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/GetDeptDailyDetail`, {
    params: params,
  });
};

//导出部门每日考勤汇�?

export const exportDeptDailyDetail = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/ExportDeptDailyDetail`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

// live_home 迟到统计（按日期分页）

export const getInSchoolSummaryByDate = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/GetInSchoolSummaryByDate`, {
    params: params,
  });
};

// live_home 迟到明细

export const getInSchoolLateDetail = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/GetInSchoolLateDetail`, {
    params: params,
  });
};

// 宿舍迟到统计（按日期分页，学生去重）

export const getHostelLateSummaryByDate = (params) => {
  return axios.get(
    `${base}/api/KqtGatherRawHistory/GetHostelLateSummaryByDate`,
    {
      params: params,
    },
  );
};
// 宿舍迟到明细（按学生分页，每个学生多次迟到记录）

export const getHostelLateDetail = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/GetHostelLateDetail`, {
    params: params,
  });
};

// 周末迟到统计（按日期分页，学生去重）

export const getWeekendLateInSummary = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/GetWeekendLateInSummary`, {
    params: params,
  });
};

// 周末迟到明细（按学生分页，每个学生多次迟到记录）

export const getWeekendLateInDetail = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/GetWeekendLateInDetail`, {
    params: params,
  });
};

// 请假未归异常汇�?

export const getLeaveStudentReturnExceptionSummary = (params) => {
  return axios.get(
    `${base}/api/KqtGatherRawHistory/GetLeaveStudentReturnExceptionSummary`,
    {
      params: params,
    },
  );
};

//  请假未归异常明细

export const getLeaveStudentReturnExceptionDetail = (params) => {
  return axios.get(
    `${base}/api/KqtGatherRawHistory/GetLeaveStudentReturnExceptionDetail`,
    {
      params: params,
    },
  );
};

// 导出 live_home 迟到汇总

export const exportInSchoolLateSummaryAndDetail = (params) => {
  return axios.get(
    `${base}/api/KqtGatherRawHistory/ExportInSchoolLateSummaryAndDetail`,
    {
      params: params,
      responseType: "blob", // 指定响应类型�?blob
    },
  );
};

//导出宿舍迟到汇�?�?

export const exportHostelLateSummaryAndDetail = (params) => {
  return axios.get(
    `${base}/api/KqtGatherRawHistory/ExportHostelLateSummaryAndDetail`,
    {
      params: params,
      responseType: "blob", // 指定响应类型�?blob
    },
  );
};

//导出周末迟到汇�?�?

export const exportWeekendLateInSummaryAndDetail = (params) => {
  return axios.get(
    `${base}/api/KqtGatherRawHistory/ExportWeekendLateInSummaryAndDetail`,
    {
      params: params,
      responseType: "blob", // 指定响应类型�?blob
    },
  );
};

//导出请假未归异常汇�?�?

export const exportLeaveStudentReturnExceptionSummaryAndDetail = (params) => {
  return axios.get(
    `${base}/api/KqtGatherRawHistory/ExportLeaveStudentReturnExceptionSummaryAndDetail`,
    {
      params: params,
      responseType: "blob", // 指定响应类型�?blob
    },
  );
};

export const getSendProgress = (params) => {
  return axios.get(`${base}/api/KqtGatherRawHistory/GetSendProgress`, {
    params: params,
  });
};

// 考勤终端设备�?

export const getKqtDeviceTerminalListPage = (params) => {
  return axios.get(`${base}/api/KqtDeviceTerminal/get`, { params: params });
};

/** 按列表筛选条件导出终端 Excel。创建于 2026-10-08 */
export const exportKqtDeviceTerminals = (params) => {
  return axios.get(`${base}/api/KqtDeviceTerminal/ExportTerminals`, {
    params: params,
    responseType: "blob",
  });
};

export const removeKqtDeviceTerminal = (params) => {
  return axios.delete(`${base}/api/KqtDeviceTerminal/delete`, {
    params: params,
  });
};

export const editKqtDeviceTerminal = (params) => {
  return axios.put(`${base}/api/KqtDeviceTerminal/put`, params);
};

export const addKqtDeviceTerminal = (params) => {
  return axios.post(`${base}/api/KqtDeviceTerminal/post`, params);
};

/** 批量导入话机 VoIP 设备签名。创建于 2026-08-19 */
export const importVoipSignatures = (params) =>
  axios.post(`${base}/api/KqtDeviceTerminal/ImportVoipSignatures`, params);

export const refreshDeviceInfo = (params) => {
  return axios.get(`${base}/api/KqtDeviceTerminal/RefreshDeviceInfo`, {
    params: params,
  });
};

export const getDeviveList = (params) => {
  return axios.get(`${base}/api/KqtDeviceTerminal/GetDeviveList`, {
    params: params,
  });
};

export const getSyncUserRecords = (params) => {
  return axios.get(`${base}/api/KqtDeviceTerminal/GetSyncUserRecords`, {
    params: params,
  });
};

export const exportSyncUserRecords = (params) => {
  return axios.get(`${base}/api/KqtDeviceTerminal/ExportSyncUserRecords`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//清空同步记录

export const clearSyncUserRecords = (params) => {
  return axios.post(
    `${base}/api/KqtDeviceTerminal/ClearSyncUserRecords`,
    params,
  );
};

//消费记录

export const getSchoolBusTerminalListPage = (params) => {
  return axios.get(`${base}/api/SchoolBusTerminal/get`, { params: params });
};

export const removeSchoolBusTerminal = (params) => {
  return axios.delete(`${base}/api/SchoolBusTerminal/delete`, {
    params: params,
  });
};

export const editSchoolBusTerminal = (params) => {
  return axios.put(`${base}/api/SchoolBusTerminal/put`, params);
};

export const addSchoolBusTerminal = (params) => {
  return axios.post(`${base}/api/SchoolBusTerminal/post`, params);
};

//跟车�?

export const getHostelGatherRawHistoryListPage = (params) => {
  return axios.get(`${base}/api/HostelGatherRawHistory/get`, {
    params: params,
  });
};

/** 模拟宿舍考勤上报（仅 blogadmin / admin） */
export const simulateHostelReportAttendance = (data, params) => {
  return axios.post(`${base}/api/HostelScheduleDailySetting/SimulateReportAttendance`, data, {
    params: params || { skipCache: true },
  });
};

/** 模拟学生考勤上报（仅 blogadmin / admin） */
export const simulateKqtReportAttendance = (data, params) => {
  return axios.post(`${base}/api/KqtScheduleDailySetting/SimulateReportAttendance`, data, {
    params: params || { skipCache: true },
  });
};

/** 模拟校车考勤上报（仅 blogadmin / admin） */
export const simulateSchoolBusReportRecord = (data) => {
  return axios.post(`${base}/api/SchoolBus/SimulateReportRecord`, data);
};

//宿舍班级考勤

export const getCplateTerminalListPage = (params) => {
  return axios.get(`${base}/api/CplateTerminal/get`, { params: params });
};


//编辑班牌终端管理

export const editCplateTerminal = (params) => {
  return axios.put(`${base}/api/CplateTerminal/put`, params);
};
//新增班牌终端管理

export const addCplateTerminal = (params) => {
  return axios.post(`${base}/api/CplateTerminal/post`, params);
};
//删除班牌终端管理

export const deleteCplateTerminal = (params) => {
  return axios.delete(`${base}/api/CplateTerminal/Delete`, { params: params });
};

/** 批量删除班牌终端。创建于 2026-09-12 */
export const batchDeleteCplateTerminal = (params) => {
  return axios.delete(`${base}/api/CplateTerminal/BatchDelete`, { params: params });
};

//班牌授权下发

export const authCplateTerminal = (params) => {
  return axios.post(`${base}/api/CplateTerminal/CplateAuth`, params);
};

/** 班牌开通话机。创建于 2026-08-07 */
export const enableCplatePhone = (params) =>
  axios.post(`${base}/api/CplateTerminal/EnablePhone`, null, { params });

/** 批量为班牌开通话机。创建于 2026-08-19 */
export const enableCplatePhoneBatch = (params) =>
  axios.post(`${base}/api/CplateTerminal/EnablePhoneBatch`, params);

/** 批量导入班牌终端。创建于 2026-08-11 */
export const importCplateTerminalBatch = (params) =>
  axios.post(`${base}/api/CplateTerminal/ImportBatch`, params);

/** 导出班牌终端。创建于 2026-08-19 */
export const exportCplateTerminals = (params) =>
  axios.get(`${base}/api/CplateTerminal/Export`, {
    params,
    responseType: 'blob',
    skipGlobalHttpErrorToast: true
  });

//查询门禁规则

export const batchAuthorizeTerminals = (params) => {
  return axios.post(
    `${base}/api/PowerOnOffSchedule/BatchAuthorizeTerminals`,
    params,
  );
};

//下发指令

export const getCommPhoneTerminalRuleByTerminalId = (params) =>
  axios.get(`${base}/api/CommPhoneTerminalRule/GetByTerminalId`, { params });

export const saveCommPhoneTerminalRule = (params) => axios.post(`${base}/api/CommPhoneTerminalRule/Save`, params);

export const saveCommPhoneTerminalRuleBatch = (params) => axios.post(`${base}/api/CommPhoneTerminalRule/BatchSave`, params);

export const getKqtCameraListBySchool = (params) =>
  axios.get(`${base}/api/KqtCameraDevice/GetListBySchool`, { params });
/** 获取在线摄像头的ID列表 */

export const getKqtCameraOnlineDeviceIds = () =>
  axios.get(`${base}/api/KqtCameraDevice/GetOnlineDeviceIds`);

/** 分页获取天敏摄像头同步主日志 */
